import YCol from './Col';

export { YCol };
export default YCol;
